import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
Swiper.use([ A11y, Navigation]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-testimonials').length) {
    new Swiper('.swiper-testimonials', {
      slidesPerView: 1,
      spaceBetween: 15,
      speed: 1000,
      loop: true,
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: '.swiper-testimonials-navigation .swiper-button-next',
        prevEl: '.swiper-testimonials-navigation .swiper-button-prev',
      },
    });
  }
});
